export default __webpack_public_path__ + "static/media/cnbc.2452d9df.png";